import "../../../public/js/config";

export const API_URL = window.APP_URL;
